import { getApolloClientSingleton } from 'lib/apollo/client/browser';
import REACTION_SUMMARY_FRAGMET from './ReactionSummaryFragment.gql';
import type { ReactionSummaryFragment } from './__generated__/ReactionSummaryFragment';

export function getReactionSummary(messageUuid: string): ReactionSummaryFragment | null {
  const client = getApolloClientSingleton();
  const data = client.readFragment<ReactionSummaryFragment>({
    id: client.cache.identify({ __typename: 'ReactionSummary', messageUuid }),
    fragment: REACTION_SUMMARY_FRAGMET,
  });

  return data;
}

export function currentReactionSummaryVersion(messageUuid: string): number {
  const data = getReactionSummary(messageUuid);

  return data?.version ?? -1;
}

export function saveReactionSummary(reactionSummary?: ReactionSummaryFragment | null): void {
  if (!reactionSummary || !reactionSummary.messageUuid) {
    console.warn('saveReactionSummary received a falsy reactionSummary arg', reactionSummary);
    return;
  }
  const client = getApolloClientSingleton();

  client.writeFragment<ReactionSummaryFragment>({
    id: client.cache.identify({ ...reactionSummary }),
    fragment: REACTION_SUMMARY_FRAGMET,
    data: reactionSummary,
  });
}
